// Shared between in-room dining (FoodRequest) and the QR table menu
// (RestaurantDining) so the two screens cannot drift apart: the table menu is
// meant to look and read exactly like the in-room one.

export const DIET_FILTERS = [
    { key: "VEG", label: "Veg" },
    { key: "EGG", label: "Egg" },
    { key: "NON_VEG", label: "Non-veg" },
];

export const titleCase = (value) =>
    String(value || "").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

// The cuisine tabs a menu yields, alphabetical with anything unlabelled last.
export const orderedTypes = (menu) => {
    const found = [...new Set((menu || []).map(food => food.type || 'Other'))];
    return found.sort((a, b) => {
        if (a === 'Other') return 1;
        if (b === 'Other') return -1;
        return a.localeCompare(b);
    });
};

// Availability windows are minutes past midnight in hotel-local time. A window whose end
// is not after its start wraps midnight -- that is how a 10 PM to 2 AM late-night item is
// expressed -- so the wrap case is checked explicitly rather than assuming start < end.
export const minuteOfDayNow = (date = new Date()) =>
    date.getHours() * 60 + date.getMinutes();

export const windowCovers = (window, minuteOfDay) => {
    if (window.start_minute === window.end_minute) return true;
    if (window.start_minute < window.end_minute) {
        return minuteOfDay >= window.start_minute && minuteOfDay < window.end_minute;
    }
    return minuteOfDay >= window.start_minute || minuteOfDay < window.end_minute;
};

// An item with no windows is served all day. That is the same rule the backend applies in
// models.MenuItem.IsAvailableAt, and it is what un-migrated items fall back to.
export const isServedNow = (windows, minuteOfDay = minuteOfDayNow()) => {
    if (!windows || windows.length === 0) return true;
    return windows.some((window) => windowCovers(window, minuteOfDay));
};

export const minuteToClock = (minute) => {
    const hours = Math.floor(minute / 60);
    const minutes = minute % 60;
    const suffix = hours < 12 ? "AM" : "PM";
    const displayHour = hours % 12 === 0 ? 12 : hours % 12;
    return minutes === 0
        ? `${displayHour} ${suffix}`
        : `${displayHour}:${String(minutes).padStart(2, "0")} ${suffix}`;
};

export const describeWindows = (windows) => {
    if (!windows || windows.length === 0) return "";
    return windows
        .map((window) => `${minuteToClock(window.start_minute)} - ${minuteToClock(window.end_minute)}`)
        .join(" | ");
};
